import * as React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import Localization from '~/client/src/shared/localization/LocalizationManager'

import BaseCompactPopup from '../BaseCompactPopup/BaseCompactPopup'
import { Radio, RadioGroup } from '../shadcn-ui/radio-group'

import './CompactGroupByFilter.scss'

interface IProps {
  isShown: boolean
  selectedMode: string
  onHide: (event?: React.SyntheticEvent<HTMLDivElement>) => void
  onGroupByChange: (bandType: string) => void
  groupByOptions: IGroupByOption[]
}

export interface IGroupByOption {
  title: string
  groupByType: string
  icon?: JSX.Element
  shouldRenderSeparator?: boolean
}

@observer
export default class CompactGroupByPicker extends React.Component<IProps> {
  public render() {
    const { isShown, onHide } = this.props

    return (
      <BaseCompactPopup
        title={Localization.translator.groupBy}
        isShown={isShown}
        onHide={onHide}
      >
        {this.renderContent()}
      </BaseCompactPopup>
    )
  }

  private renderContent(): JSX.Element {
    const { groupByOptions, selectedMode, onGroupByChange } = this.props

    return (
      <RadioGroup
        className="compact-group-by-container tw:flex tw:flex-col tw:px-2.5"
        value={selectedMode}
        onValueChange={onGroupByChange}
      >
        {groupByOptions.map(
          ({ title, groupByType, shouldRenderSeparator, icon }, index) => {
            const isOptionSelected = groupByType === selectedMode
            return (
              <div key={index}>
                <label
                  className={classList({
                    'group-by-option tw:flex tw:items-center tw:gap-2 tw:cursor-pointer tw:select-none': true,
                    active: isOptionSelected,
                  })}
                >
                  <Radio value={groupByType} />
                  <div className="text large bold row">
                    {icon}
                    {title}
                  </div>
                </label>
                {shouldRenderSeparator && (
                  <div className="bb-light-input-border" />
                )}
              </div>
            )
          },
        )}
      </RadioGroup>
    )
  }
}
